import { Radio } from '@blueprint/ui';
import { Stack } from '@zoopla-eng/zds-components/stack';
import { FiltersLabel } from '@zoopla/listing-search/filters/modal';

const transportTypeOptions = {
    driving: 'Driving',
    walking: 'Walking',
    walking_train: 'Train',
    public_transport: 'Public transport',
    cycling: 'Cycling'
};

export type TransportType = keyof typeof transportTypeOptions;

type SelectTransportModeProps = {
    value: TransportType;

    onChange: (transportType: TransportType) => void;
};

export const SelectTransportMode = ({
    value,
    onChange
}: SelectTransportModeProps) => {
    const transportTypeLabel = 'Transport mode';

    return (
        <>
            <FiltersLabel htmlFor="modal-price-filter">
                {transportTypeLabel}
            </FiltersLabel>
            <Stack
                flexDirection="row"
                flexWrap="wrap"
                columnGap="0"
                rowGap="0"
                items={{
                    width: '50%'
                }}
            >
                {Object.keys(transportTypeOptions).map((transportType) => {
                    return (
                        <Radio
                            key={`modal_transport_type_${transportType}`}
                            id={`modal_transport_type_${transportType}`}
                            data-testid={value}
                            name="transportTypeOption"
                            label={
                                transportTypeOptions[
                                    transportType as TransportType
                                ]
                            }
                            checked={value === transportType}
                            onChange={(e) => {
                                onChange(e.target.value as TransportType);
                            }}
                            value={transportType}
                        />
                    );
                })}
            </Stack>
        </>
    );
};
